export const question = [
  '0 0 32 32',
  `
<path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.56" d="M16 30.5c8.008 0 14.5-6.492 14.5-14.5s-6.492-14.5-14.5-14.5c-8.008 0-14.5 6.492-14.5 14.5s6.492 14.5 14.5 14.5z"></path>
<path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.56" d="M16 18.417v-1.208c0.836 0 1.654-0.248 2.35-0.713s1.238-1.125 1.558-1.898 0.404-1.623 0.241-2.444c-0.163-0.82-0.566-1.574-1.157-2.165s-1.345-0.994-2.165-1.157c-0.821-0.163-1.671-0.079-2.444 0.241s-1.433 0.862-1.898 1.558c-0.465 0.696-0.713 1.513-0.713 2.35"></path>
<path d="M16 25.667c1.001 0 1.813-0.811 1.813-1.813s-0.811-1.813-1.813-1.813c-1.001 0-1.813 0.811-1.813 1.813s0.812 1.813 1.813 1.813z"></path>

`,
]
